import React from 'react';
import {
    Link,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import InfiniteScroll from 'react-infinite-scroller';
import { BeatLoader } from 'react-spinners';

// Actions

// Styles

/*
* this.props.Reset
* this.props.Get
* this.props.GetParams
* this.props.ListItem
* this.props.IsReverse
* this.props.EmptyText
*/

class InfiniteList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],

            skip: 0,
            limit: 10,
            isLoading: false,
            hasMore: true,
        };

        this.getList = this.getList.bind(this);
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
        if (this.props.Reset) this.props.dispatch(this.props.Reset());
        this.setState({
            list: [],
            skip: 0,
            isLoading: false,
            hasMore: true,
        });
        console.log(this.props.params);
        this.getList();
    }
    getList() {
        if (!this.state.isLoading && this.state.hasMore) {
            this.setState({ isLoading: true });
            let params = this.props.params;
            console.log(this.props.params);
            this.props.dispatch(this.props.getList({
                    skip: this.state.skip,
                    ...params
                })).then((res) => {
                    let {list=[], total} = res
                    console.log(list, this.state.limit);
                    if (list.length === 0 || (list.length < this.state.limit)) {
                        this.setState({
                            hasMore: false,
                            isLoading: false,
                        });
                    }
                    this.setState({
                        skip: this.state.skip + this.state.limit,
                        list: [...this.state.list, ...list],
                        isLoading: false,
                    }, () => {
                        let filtered = [];
                        let productReleaseCode = '';
                        for (let item of this.state.list) {
                            if (item.productReleaseCode !== productReleaseCode) {
                                filtered.push(item);
                                productReleaseCode = item.productReleaseCode;
                            }
                        }

                        this.setState({ list: filtered });
                        console.log(this.state);
                    });
                }).catch((err) => {
                    this.setState({
                        hasMore: false,
                        isLoading: false,
                    });
                });
        }
    }
    reset() {
        this.setState({
            list: [],
            skip: 0,
            limit: 10,
            isLoading: false,
            hasMore: true,
        }, () => {
            this.getList();
        });
    }
    render() {
        let list = this.state.list.map((doc, index) => {
            return this.props.listItem(doc, index);
        });
        if (this.props.IsReverse) {
            list = this.state.list.slice(0).reverse().map((doc, index) => {
                return this.props.listItem(doc, index);
            });
        }
        let loader = (
            <div style={{position: 'relative', margin: '20px auto 0', width: '48px', clear:'both'}} key={0}>
                <BeatLoader size={12} color={'#98a0ab'} css={{clear: 'both'}}/>
            </div>
        );
        return (
            <div className={this.props.customTableStyle || ''} style={this.props.customStyle}>
                <InfiniteScroll
                    pageStart={0}
                    loader={loader}
                    loadMore={this.getList}
                    initialLoad={false}
                    hasMore={this.state.hasMore}
                    isReverse={this.props.IsReverse}
                >
                    { list }
                    { !this.state.hasMore && this.state.list.length == 0 ? (
                        <div style={{ margin: '2px' }}>{ this.props.EmptyText ? this.props.EmptyText : '목록이 없습니다.' }</div>
                    ) : null }
                </InfiniteScroll>
            </div>
        );
    }
}
export default connect()(withRouter(InfiniteList));
